<div class="flex flex-1 flex-row">
	<div class="w-1/2">
		<h2>Heat</h2>
		<div class="mr-5 mt-5">
			<app-select
				label="Type"
				[(ngModel)]="adjustment.heatType"
				(ngModelChange)="changed()"
			>
				<option value="electric">Electric</option>
				<option value="gas">Gas</option>
				<option value="propane">Propane</option>
				<option value="oil">Oil</option>
			</app-select>
			<app-select
				label="Unit"
				[(ngModel)]="adjustment.unit"
				(ngModelChange)="changed()"
				[disabled]="
					adjustment.heatType !== 'propane' && adjustment.heatType !== 'oil'
				"
			>
				<option value="litre">Litres</option>
				<option value="gallon">Gallon</option>
			</app-select>
			<app-input
				type="number"
				label="Capacity ({{ adjustment.unit }}s)"
				name="capacity"
				class="mt-3"
				[(ngModel)]="adjustment.capacity"
				(ngModelChange)="changed()"
				[disabled]="
					adjustment.heatType !== 'propane' && adjustment.heatType !== 'oil'
				"
			></app-input>
			<app-input
				type="cents"
				label="Cost per {{ adjustment.unit }}"
				name="taxCost"
				class="mt-3"
				[startIcon]="ICON.DOLLAR"
				decimalValues="4"
				[(ngModel)]="adjustment.cost"
				(ngModelChange)="changed()"
				[disabled]="
					adjustment.heatType !== 'propane' && adjustment.heatType !== 'oil'
				"
			></app-input>
			<div class="mt-3">
				<app-checkbox
					label="Apply carbon tax"
					[(ngModel)]="adjustment.applyCarbonTax"
					(ngModelChange)="changed()"
					[disabled]="
						adjustment.heatType !== 'propane' && adjustment.heatType !== 'oil'
					"
				></app-checkbox>
			</div>
			<app-input
				type="cents"
				*ngIf="adjustment.applyCarbonTax"
				label="Carbon tax amount per {{ adjustment.unit }}"
				name="taxAmount"
				class="mt-3"
				decimalValues="4"
				[startIcon]="ICON.DOLLAR"
				[(ngModel)]="adjustment.taxCost"
				(ngModelChange)="changed()"
				[disabled]="
					adjustment.heatType !== 'propane' && adjustment.heatType !== 'oil'
				"
			></app-input>
			<div class="mt-3">
				<app-checkbox
					label="Apply HST ({{ hst | percent }})"
					[(ngModel)]="adjustment.applyHst"
					(ngModelChange)="changed()"
					[disabled]="
						adjustment.heatType !== 'propane' && adjustment.heatType !== 'oil'
					"
				></app-checkbox>
			</div>
			<app-input
				*ngIf="creditAmount >= 0"
				type="cents"
				label="Credit vendor"
				name="credit"
				class="mt-3"
				[startIcon]="ICON.DOLLAR"
				[ngModel]="creditAmount"
				[disabled]="true"
			></app-input>
			<app-input
				*ngIf="creditAmount < 0"
				type="cents"
				label="Credit purchaser"
				name="credit"
				class="mt-3"
				[startIcon]="ICON.DOLLAR"
				[ngModel]="creditAmount * -1"
				[disabled]="true"
			></app-input>
			<div class="mt-3">
				<app-checkbox
					label="Include all details in document"
					[(ngModel)]="adjustment.details"
				></app-checkbox>
			</div>
		</div>
		<div class="flex justify-between mr-5 mt-5">
			<app-button btn="tertiary" class="mr-5" (click)="cancelModal()"
				>Cancel</app-button
			>
			<app-button (click)="saveModal()">Save</app-button>
		</div>
	</div>
	<div class="w-1/2">
		<app-container type="dark" title="Details">
			<div class="flex flex-1 flex-col">
				<div class="mb-8">
					<div
						*ngIf="
							adjustment.heatType === 'propane' || adjustment.heatType === 'oil'
						"
					>
						<div class="flex justify-between items-start mb-3">
							<div>
								{{ adjustment.capacity }} {{ adjustment.unit }}
								{{ adjustment.heatType }} tank at
								{{ adjustment.cost | centsToDollars: 4 }} per
								{{ adjustment.unit }}
							</div>
							<div>{{ totalUnitCost | centsToDollars }}</div>
						</div>
						<div
							*ngIf="adjustment.applyCarbonTax"
							class="flex justify-between items-start mb-3"
						>
							<div>
								Carbon tax at {{ adjustment.taxCost | centsToDollars: 4 }} per
								{{ adjustment.unit }}
							</div>
							<div>{{ taxAmount | centsToDollars }}</div>
						</div>
						<div
							*ngIf="adjustment.applyHst"
							class="flex justify-end items-start mb-8"
						>
							<div>
								<strong
									>HST ({{ hst | percent }}) =
									{{ hstAmount | centsToDollars }}</strong
								>
							</div>
						</div>
						<div class="flex justify-end items-start">
							<div *ngIf="creditAmount >= 0">
								<strong
									>Credit Vendor = {{ creditAmount | centsToDollars }}</strong
								>
							</div>
							<div *ngIf="creditAmount < 0">
								<strong
									>Credit Purchaser =
									{{ creditAmount * -1 | centsToDollars }}</strong
								>
							</div>
						</div>
					</div>
					<div
						*ngIf="
							adjustment.heatType !== 'propane' && adjustment.heatType !== 'oil'
						"
					>
						<div class="flex justify-end items-start mb-8">
							<div>Metered - No adjustment</div>
						</div>
					</div>
				</div>
			</div>
		</app-container>
	</div>
</div>
